import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { CurrencyPipe, DslService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

import { AccountMenuItemBase } from '../../account-menu-item-base';

@Component({
    imports: [CommonModule, CurrencyPipe],
    selector: 'vn-am-balance-tile-item',
    templateUrl: 'balance-tile-item.html',
})
export class BalanceTileItemComponent extends AccountMenuItemBase implements OnInit {
    dslService = inject(DslService);

    balance: Observable<number>;

    ngOnInit() {
        this.balance = this.dslService.evaluateExpression(this.item.parameters['balance']!);
    }
}
